import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {CompanyRmGames} from './RmGames';
import SectionNavbar from '../../components/SectionNavbar';
import {selectSelectedArea, selectSelectedRmId, storeSelectedRm} from '../../slices/selected';
import {CompanyRmAnalytics} from './RmAnalytics';
import {CompanyRm} from './Rm';
import {CompanyRmFollower} from './RmFollower';
import {getRmListener} from '../../api/company';
import {CompanyRmEditSoftSkills} from './RmEditSoftSkills';
import './style.scss';
import {useTranslation} from 'react-i18next';
import {ROUTES} from '../../db/models/const';

export const CompanyRmManage = ({topRef}) => {
    const dispatch = useDispatch();
    const rmId = useSelector(selectSelectedRmId);
    const area = useSelector(selectSelectedArea);
    const history = useHistory();
    const [navbarTitle, setNavbarTitle] = useState("");
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const {t} = useTranslation();

    // const countStudents = () => {
    //     if (!rm) return null;

    //     return Object.values(rm?.students || []).length;
    // };

    // const onBackClick = () => {
    //     if (role === "student") {
    //         dispatch(resetSelectedArea());
    //         history.push("/company/areas");
    //     }
    //     if (role === "company") {
    //         history.push("/area");
    //     }
    // };

    useEffect(() => {
        if (!rmId || !area) {
            history.push(ROUTES.ME);
            return;
        }
        const unsubscribe = getRmListener(
            {
                next: (doc) => {
                    if (doc.exists) {
                        const rm = doc.data();
                        setNavbarTitle(area.name + " - " + rm.name);
                        dispatch(storeSelectedRm({rm}));
                    }
                },
            },
            rmId
        );
        return unsubscribe;
    }, [rmId]);

    return (
        <div className="companyRmManage">
            <SectionNavbar>
                <h2>{navbarTitle}</h2>
                <div className="tabs">
                    <div className={path === "overview" ? "tab--active" : "tab"}
                         onClick={() => history.push(ROUTES.COMPANY_RM_OVERVIEW)}>{t("company_rm_nav_overview")}</div>
                    <div className={path === "analytics" ? "tab--active" : "tab"}
                         onClick={() => history.push(ROUTES.COMPANY_RM_ANALYTICS)}>{t("company_rm_nav_analytics")}</div>
                    <div className={path === "games" ? "tab--active" : "tab"}
                         onClick={() => history.push(ROUTES.COMPANY_RM_GAMES)}>{t("company_rm_nav_games")}</div>
                    {/* <div className={path === "videos" ? "tab--active" : "tab"} onClick={() => history.push(ROUTES.COMPANY_RM_VIDEOS)}>{t("company_rm_nav_videos")}</div> */}
                </div>
            </SectionNavbar>

            <Switch>
                <Route path={ROUTES.COMPANY_RM_OVERVIEW} exact component={CompanyRm}/>
                <Route path={ROUTES.COMPANY_RM_EDIT_SOFT} exact component={CompanyRmEditSoftSkills}/>
                <Route path={ROUTES.COMPANY_RM_ANALYTICS} exact component={CompanyRmAnalytics}/>
                <Route path={ROUTES.COMPANY_RM_GAMES} component={CompanyRmGames}/>
                {/* <Route path={ROUTES.COMPANY_RM_VIDEOS} component={CompanyRmVideos} /> */}
                <Route path={ROUTES.FOLLOWER} exact component={CompanyRmFollower}/>
                <Redirect to={ROUTES.COMPANY_RM_OVERVIEW}/>
            </Switch>
        </div>
    );
};
